package com.writerslab.office

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun StatsPage() {
    var stats by remember { mutableStateOf<OfficeStats?>(null) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        if (PREVIEW) { stats = MockApi.stats(); return@LaunchedEffect }
        try {
            stats = ApiClient.getStats()
        } catch (e: Throwable) {
            error = e.message ?: "Ошибка загрузки"
        }
    }

    Div({ style { property("padding", "24px 0") } }) {
        H2({ style { color(Color(C.OnSurface)); marginBottom(20.px); property("font-size", "18px") } }) {
            Text("Статистика")
        }

        if (error != null) {
            P({ style { color(Color(C.Error)) } }) { Text(error!!) }
            return@Div
        }

        if (stats == null) {
            P({ style { color(Color(C.Muted)) } }) { Text("Загрузка…") }
            return@Div
        }

        val s = stats!!

        Div({
            style {
                property("display", "grid")
                property("grid-template-columns", "repeat(auto-fill, minmax(200px, 1fr))")
                property("gap", "12px")
            }
        }) {
            StatCard("Пользователи", s.totalUsers.toString())
            StatCard("Книги (уникальные)", s.totalBooks.toString())
            StatCard("Загрузки пользователей", s.totalUserBooks.toString())
            StatCard("Pipeline: выполнено", s.doneJobs.toString(), C.Success)
            StatCard("Pipeline: активно", s.runningJobs.toString(),
                if (s.runningJobs > 0) C.Warning else C.Muted)
            StatCard("Pipeline: ошибки", s.failedJobs.toString(),
                if (s.failedJobs > 0) C.Error else C.Muted)
            StatCard("Кредиты в обороте", s.totalCreditsInCirculation.toString(), C.Primary)
            StatCard("Коды: всего", s.totalCodes.toString())
            StatCard("Коды: доступно", s.availableCodes.toString(), C.Success)
            StatCard("Коды: использовано", s.redeemedCodes.toString())
        }

        Div({ style { color(Color(C.Muted)); fontSize(11.px); property("font-weight", "600"); property("text-transform", "uppercase"); property("letter-spacing", "0.5px"); marginTop(24.px); marginBottom(8.px) } }) {
            Text("Использование фичей")
        }
        Div({
            style {
                property("display", "grid")
                property("grid-template-columns", "repeat(auto-fill, minmax(180px, 1fr))")
                property("gap", "12px")
            }
        }) {
            StatCard("Глубокий анализ (платно)", s.pipelinePaidDone.toString(), C.Primary)
            StatCard("Глубокий анализ (бесплатно)", s.pipelineFreeDone.toString(), C.Muted)
            StatCard("Аннотации (платно)", s.totalPaidAnnotations.toString(), C.Primary)
            StatCard("Аннотации (бесплатно)", s.totalFreeAnnotations.toString(), C.Muted)
            StatCard("Обложки-batch (платно)", s.totalPaidCoverBatches.toString(), C.Primary)
            StatCard("Обложки-regen (платно)", s.totalPaidCoverRegens.toString(), C.Primary)
            StatCard("Обложки-batch (бесплатно)", s.totalFreeCovers.toString(), C.Muted)
            StatCard("Тизеры (платно)", s.totalPaidTeasers.toString(), C.Primary)
            StatCard("Тизеры (бесплатно)", s.totalFreeTeasers.toString(), C.Muted)
        }

        Div({ style { marginTop(16.px) } }) {
            SmallButton("Обновить") {
                scope.launch {
                    error = null
                    stats = null
                    if (PREVIEW) { stats = MockApi.stats(); return@launch }
                    try { stats = ApiClient.getStats() }
                    catch (e: Throwable) { error = e.message ?: "Ошибка" }
                }
            }
        }
    }
}

@Composable
private fun StatCard(label: String, value: String, valueColor: String = C.OnSurface) {
    Div({
        style {
            card()
            property("display", "flex")
            property("flex-direction", "column")
            property("gap", "6px")
        }
    }) {
        Span({ style { label() } }) { Text(label) }
        Span({
            style {
                fontSize(28.px)
                property("font-weight", "700")
                property("line-height", "1")
                color(Color(valueColor))
            }
        }) { Text(value) }
    }
}

@Composable
fun SmallButton(text: String, onClick: () -> Unit) {
    Button({
        style { btn() }
        onClick { onClick() }
    }) { Text(text) }
}
